import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Outlet, useLocation, useNavigate } from 'react-router';

import CentralizedSpinner from 'components/CentralizedSpinner';
import featureFlags from 'constants/featureFlags';
import RightSidebar from 'components/Layout/RightSidebar';
import FluxFileUploadForm from 'components/Flux/Upload/Form';
import TabbedPage from 'components/TabbedPage';
import MobileSectionHeader from 'components/Layout/MobileShell/MobileSectionHeader';
import SectionTabs, { SectionTabItem } from 'components/Layout/MobileShell/SectionTabs';
import MoreSheet from 'components/Layout/MobileShell/MoreSheet';
import shortenedTabPath from 'helper/shortenedTabPath';
import usePermissionCheck from 'utils/hooks/usePermissionCheck';
import useIsMobile from 'utils/hooks/useIsMobile';

const MOBILE_TABS: SectionTabItem[] = [
  { title: 'Meus Estudos', path: '/flux/upload' },
  { title: 'Novo Estudo Upload', path: '/flux/upload/new' },
];

export default function FluxUploadWrapper() {
  const keySaved = usePermissionCheck('prevs-personalizado');
  const isMobile = useIsMobile();
  const location = useLocation();
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);
  // Com a aba nova (flag), a sidebar com o formulário some em "Meus Estudos", como no
  // Personalizado; com a flag desligada a tela legada continua igual (formulário sempre visível).
  const sidebarFollowsTab = featureFlags.fluxUploadMeusEstudosV2;
  const [showControlPanel, setShowControlPanel] = useState(false);

  if (!keySaved) {
    return <CentralizedSpinner />;
  }

  if (isMobile) {
    const activeTab = MOBILE_TABS.find(
      (tab) => tab.path === shortenedTabPath(location.pathname),
    );

    return (
      <>
        <MobileSectionHeader
          backLabel="Upload"
          title={activeTab?.title ?? ''}
          onBack={() => navigate('/flux')}
          onAvatarClick={() => setMoreOpen(true)}
        />
        <SectionTabs tabs={MOBILE_TABS} />
        <Outlet />
        <MoreSheet open={moreOpen} dismiss={() => setMoreOpen(false)} />
      </>
    );
  }

  return (
    <>
      <Row>
        <Col className="md-6">
          <h1 className=" mb-3">FLUX - UPLOAD</h1>
        </Col>
      </Row>
      <Row style={{ flexWrap: 'nowrap', paddingBottom: '3.3125rem' }}>
        <Col xs="auto" className="flex-fill overflow-hidden">
          <TabbedPage
            setControlPanelVisibility={sidebarFollowsTab ? setShowControlPanel : undefined}
          >
            <TabbedPage.Tab title="MEUS ESTUDOS" path="/flux/upload" />
            <TabbedPage.Tab title="NOVO ESTUDO UPLOAD" path="/flux/upload/new" showControlPanel />
          </TabbedPage>
        </Col>
        {(!sidebarFollowsTab || showControlPanel) && (
          <Col xs="auto">
            <RightSidebar>
              <FluxFileUploadForm />
            </RightSidebar>
          </Col>
        )}
      </Row>
      <div className="bottom-bar" />
    </>
  );
}
